import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { get } from 'lodash';
import { createUseStyles } from 'react-jss';
import { connect } from 'react-redux';
import { styles } from './formStyles';
import LoaderButton from '../LoaderButton/LoaderButton';
import { ACCEPT_BUY_NOW_CONTRACT, CLEAR_DETAILS_DATA, SET_DETAILS_TAB } from '../../redux/OffersDetails';
import ThankYouImage from '../../images/thank_you.png';
import { navigationMapping } from '../../consts/navigation';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

const BuyNowModal = ({ t, brandName, model, price, acceptBuyNowContract,
                       buyNowId, isLoadingBuyNow, closeModal, setDetailsTab,
                       history, contractAccepted, clearDetailsData, hashId, }) => {
  const classes = useStyles();
  return (
    <div>
      { contractAccepted
        ? (
          <div className={classes.thanksSection}>
            <img src={ThankYouImage} alt="thank_you_image" />
            <h4>
              {t('thanks_for_business')}
            </h4>
            <div className={classes.buttonContainer}>
              <LoaderButton
                label={t('got_it')}
                dataTestId="gotIt"
                className={classes.buyNowButton}
                onClick={() => {
                  closeModal();
                  clearDetailsData();
                  setDetailsTab({ tabName: 'CONTACT_TAB', });
                  history.push({
                    pathname: `${navigationMapping.in_realization.details_url}/${hashId}`,
                    state: { whichFolder: 'in_realization', },
                  });
                }}
              />
            </div>
          </div>
        ) : (
          <div className={classes.buyNowModal}>
            <h4> {t('confirm')} </h4>
            <p>
              <strong> {brandName} {model} ({hashId}) </strong>
            </p>
            <p>
              {t('amount')}
              <strong> {price} &euro; </strong>
            </p>
            <div className={classes.buttonSection}>
              <button
                className={classes.cancelButton}
                onClick={() => closeModal()}
              >
                {t('cancel')}
              </button>
              <LoaderButton
                label={t('buy_now_confirm')}
                dataTestId="approveBuyNow"
                className={classes.buyNowButton}
                isLoading={isLoadingBuyNow}
                onClick={
                  () => acceptBuyNowContract({ buyNowId, })
                }
              />
            </div>
          </div>
        )
      }
    </div>
  );
};

BuyNowModal.propTypes = {
  t: PropTypes.func.isRequired,
  brandName: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  acceptBuyNowContract: PropTypes.func.isRequired,
  buyNowId: PropTypes.number.isRequired,
  isLoadingBuyNow: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  history: PropTypes.func.isRequired,
  contractAccepted: PropTypes.bool,
  clearDetailsData: PropTypes.func.isRequired,
  hashId: PropTypes.string.isRequired,
  setDetailsTab: PropTypes.func.isRequired,
};

BuyNowModal.defaultProps = {
  isLoadingBuyNow: false,
  contractAccepted: false,
};

const useStyles = createUseStyles({
  buyNowModal: {
    color: styles.colors.darkGray,
    padding: '2em',
    '& h4': {
      textAlign: 'center',
      fontWeight: '700',
    },
    '& p': {
      fontSize: '18px',
      lineHeight: '25px',
    },
    '& p:first-of-type': {
      marginTop: '2em',
    },
  },
  buyNowButton: {
    height: '50px',
    padding: '0px 20px',
    minWidth: 'unset',
    marginTop: '0px',
  },
  cancelButton: {
    color: styles.colors.darkGray,
    fontWeight: '700',
    fontSize: '16px',
    border: 'none',
    borderRadius: '5px',
    padding: '0px 20px',
    height: '50px',
  },
  buttonSection: {
    marginTop: '2em',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  thanksSection: {
    textAlign: 'center',
    marginTop: '1em',
    '& h4': {
      marginTop: '2em',
    },
  },
  buttonContainer: {
    margin: 'auto',
    width: 'fit-content',
    marginTop: '2em',
  },
  '@media (max-width: 340px)': {
    buyNowModal: {
      padding: '2px',
    },
  },
});

const mapStateToProps = (state) => {
  return {
    hashId: get(state, ['offerDetails', 'data', 'hash_id']),
    brandName: get(state, ['offerDetails', 'data', 'vehicle', 'brand', 'name']),
    model: get(state, ['offerDetails', 'data', 'vehicle', 'model']),
    price: get(state, ['offerDetails', 'data', 'buy_now_contract', 'price']),
    buyNowId: get(state, ['offerDetails', 'data', 'buy_now_contract', 'id']),
    isLoadingBuyNow: get(state, ['offerDetails', 'isLoadingBuyNow']),
    contractAccepted: get(state, ['offerDetails', 'buyNowContractAccepted']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    acceptBuyNowContract: (id) => dispatch(ACCEPT_BUY_NOW_CONTRACT(id)),
    clearDetailsData: () => dispatch(CLEAR_DETAILS_DATA()),
    setDetailsTab: (tabName) => dispatch(SET_DETAILS_TAB(tabName)),
  };
};


export default compose(
    withRouter,
    withScopedTranslations('dealers_offers'),
    connect(mapStateToProps, mapDispatchToProps)
  )(BuyNowModal);
